"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectResponseModelAccessLevel = void 0;
exports.ProjectResponseModelAccessLevel = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
